export default __webpack_public_path__ + "static/viz/media/opensearch-icon.e3147b39.svg";